import $ from 'jquery';
import * as Base from './components/Bootstrap/Modal';
import Vue from 'vue';
import {equals} from 'ramda';

const empty = (parent) => {
    do {
        parent.removeChild(parent.firstChild);
    } while (parent.firstChild !== null);
}

const html = (content, target) => {
    if (!target)
        return;

    empty(target);
    target.insertAdjacentHTML('afterbegin', content);
}

export const defaults = Vue.observable({
    template: 'desktop',
});

const template = (name) => equals(defaults.template, name);

const ButtonClose_v1 = () => (
    <button class="close" data-dismiss="modal">
        <svg class="icon-close" viewBox="-18 -18 36 36">
            <path d="M-7.5,-7.5 l15,15"/>
            <path d="M-7.5,7.5 l15,-15"/>
        </svg>
    </button>
);

const ButtonClose_v2 = () => (
    <button class="pt-1 pr-1" data-dismiss="modal">
        <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M21.1934 0.822453C20.5624 0.191433 19.543 0.191433 18.912 0.822453L11 8.7183L3.08798 0.806273C2.45696 0.175253 1.43762 0.175253 0.806599 0.806273C0.175579 1.43729 0.175579 2.45663 0.806599 3.08765L8.71862 10.9997L0.806599 18.9117C0.175579 19.5427 0.175579 20.5621 0.806599 21.1931C1.43762 21.8241 2.45696 21.8241 3.08798 21.1931L11 13.2811L18.912 21.1931C19.543 21.8241 20.5624 21.8241 21.1934 21.1931C21.8244 20.5621 21.8244 19.5427 21.1934 18.9117L13.2814 10.9997L21.1934 3.08765C21.8082 2.47281 21.8082 1.43729 21.1934 0.822453Z"/>
        </svg>
    </button>
);

const Modal = {
    props: ['initialTitle'],
    data: function () {
        return {
            title: this.initialTitle,
        }
    },
    mixins: [Base.Mixin],
    mounted() {
        const modal = (this.$el).querySelector('.modal') || this.$el;
        const modalDialog = modal.querySelector('.modal-dialog');

        modalDialog.classList.add('modal-dialog-centered');
        modalDialog.setAttribute('role', 'dialog');
        initModal(modal);
    },
    render() {
        return (
            <Base.Wrapper>
                <div class="modal-header">
                    <div class="modal-title">
                        {this.title}
                    </div>
                    {template('desktop') ? <ButtonClose_v1/> : null}
                    {template('mobile') ? <ButtonClose_v2/> : null}
                </div>
                <div class="modal-body">
                    {this.$slots.default}
                </div>
            </Base.Wrapper>
        );
    }
}

export const initModal = (element) => $(element).modal({show: false});

export function create({title, body, attrs, target}) {
    const vueModal = new Vue({
        render() {
            return (
                <Modal initialTitle={title} attrs={attrs}>
                    <div domPropsInnerHTML={body}></div>
                </Modal>
            );
        }
    });

    if (target instanceof HTMLElement)
        vueModal.$mount(target);
    else {
        vueModal.$mount();
        document.body.appendChild(vueModal.$el);
    }

    return $(vueModal.$el);
}

const find = (selector, parent) => parent.querySelector(selector);
const title = (parent) => find('.modal-title', parent);
const body = (parent) => find('.modal-body', parent);

export const setTitle = (parent, content) => html(content, title(parent));
export const appendBody = (parent, content) => html(content, body(parent));

export default Modal;
